module.exports = __webpack_public_path__ + "img/icon-telefon.eb75363a.svg";